import React from "react";

import Tabs from "../../components/Tabs/Tabs";
import PageTitle from "../../components/PageTitle/PageTitle";

import PredictionsAccuracy from "../PredictionsAccuracy/PredictionsAccuracy";

import "./Leaderboards.css";

const Leaderboards = () => {
    return (
        <div>
            <div className="page-part-grey">
                <PageTitle />
            </div>
            <Tabs />
            <PredictionsAccuracy />
        </div>
    );
};

export default Leaderboards;


